import { isAudit } from "../../helpers";
import { useActivityTemplate } from "./use_activity_template";

export const useIsAudit = () => {
  const template = useActivityTemplate();

  return isAudit(template);
};
